import { useState } from 'react';
import classNames from 'classnames';
import { nanoid } from '@reduxjs/toolkit';

type Props = {
  content: React.ReactNode;
  button: React.ReactNode;
  open: boolean;
  borderColor?: 'gray' | 'blue' | 'none';
  direction?: 'top' | 'bottom';
  customClassName?: string;
};

const Accordion = ({
  content,
  button,
  open,
  borderColor = 'blue',
  direction = 'top',
  customClassName,
}: Props) => {
  const [id] = useState(nanoid(12));
  const accordionWrapperClass = classNames(
    'border rounded-md',
    {
      'border-none': borderColor === 'none',
      'border-teal-500': borderColor === 'blue',
      'border-gray-200': borderColor === 'gray',
    },
    customClassName
  );

  if (direction === 'top')
    return (
      <div className={accordionWrapperClass}>
        <div
          id={`accordion-${id}-top`}
          className={classNames('grid transition-grid-template-rows duration-300', {
            'grid-rows-[0fr]': !open,
            'grid-rows-[1fr]': open,
          })}
        >
          <div className="overflow-hidden">{content}</div>
        </div>
        {button}
      </div>
    );

  return (
    <div className={accordionWrapperClass}>
      {button}
      <div
        id={`accordion-${id}-bottom`}
        className={classNames('grid transition-grid-template-rows duration-300', {
          'grid-rows-[0fr]': !open,
          'grid-rows-[1fr]': open,
        })}
      >
        <div className="overflow-hidden">{content}</div>
      </div>
    </div>
  );
};

export default Accordion;
